import React from 'react';
import { useTheme } from 'styled-components';
import { Box, Button, Text } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

interface ChangeAccountButtonProps {
  accountName: string;
  accountNumber: string;
  onChangeAccount: () => void;
  numberOfAccounts: number;
}

const ChangeAccountButton = ({
  accountName,
  accountNumber,
  onChangeAccount,
  numberOfAccounts,
}: ChangeAccountButtonProps) => {
  const { palette } = useTheme();

  return (
    <LinkRegion isNotTracked>
      <Box mb="s3">
        <Text variant="bodyMDemi">{accountName}</Text>
        <Text variant="bodySMedium" color={palette.baseColors.mawheranui}>
          {`Account number: #${accountNumber}`}
        </Text>
        {numberOfAccounts > 1 ? (
          <LinkRegion regionId="productDetails.line.yourPlans">
            <Button variant="textbutton" onClick={onChangeAccount}>
              Change account
            </Button>
          </LinkRegion>
        ) : null}
      </Box>
    </LinkRegion>
  );
};

export default ChangeAccountButton;
